const NAME_PATTERN = /^\s*[-a-zA-Z-]+\s*$/;

export const isValidPatientName = (
  value: string | null | undefined,
  maxLength: number
): boolean => {
  if (!value) return false;

  return NAME_PATTERN.test(value) && value.trim().length <= maxLength;
};

export { NAME_PATTERN };
